import { useTranslation } from 'react-i18next';
import CreateStore from './CreateStore';

export default function StoreSetup() {
  const { t } = useTranslation();

  return <CreateStore />;
}
